import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LeftNavigationModule } from './left-navigation/left-navigation.module';
import { TopBannerModule } from './top-banner/top-banner.module';
import { FooterModule } from './footer/footer.module';
import { DatePickerModule } from './date-picker/date-picker.module';
import { EventsEmitter } from './event-emitter/EventEmitter';
import { DateRangePickerModule } from './date-range-picker/date-range-picker.module';
import { BackgroundFileUploaderModule } from './background-file-uploader/background-file-uploader.module';
import { EmailInputComponent } from './email-input/email-input.component';
import { SearchDropDownModule } from './search-dropdown/search-dropdown.module';
import { NotificationTemplateModule } from './notification-template/notification-template.module';
import { SearchBoxModule } from './search-box/search-box.module';



@NgModule({
  declarations: [  
  ],
  imports: [
    CommonModule,
    LeftNavigationModule,
    TopBannerModule,
    FooterModule,
    DatePickerModule,
    DateRangePickerModule,
    SearchDropDownModule,
    BackgroundFileUploaderModule,
    EmailInputComponent,
    NotificationTemplateModule,
    SearchBoxModule
  ],
  exports: [
    LeftNavigationModule,
    TopBannerModule,
    FooterModule,
    DatePickerModule,
    DateRangePickerModule,
    SearchDropDownModule,
    BackgroundFileUploaderModule,
    EmailInputComponent,
    NotificationTemplateModule,
    SearchBoxModule
  ],
  providers: [EventsEmitter]
})
export class SharedModule {}
